import React, {useEffect} from "react";
import TotalDataComponent from "../../../components/total-data.component";
import {Wishlist} from "./wishlist";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import {useFetch} from "../../../services/useFetch";
import {API} from "../../../services/api";
import {setToolsInitialState} from "../../../reducers/tools.reducer";

const TabWishlist = () => {
    const dispatch = useDispatch()
    const {id} = useParams()
    const {currentPage, pageSize} = useSelector(state => state.toolsReducer)
    const queryParams = {
        page: currentPage,
        perPage: pageSize,
    }
    const {data: response, fetching: getWishlist, isLoading} = useFetch({...API.USER_WISHLIST, ...{initPathVariable: id}}, queryParams, {isWithTotalData: true})

    useEffect(() => {
        getWishlist()
    }, [currentPage, id])

    useEffect(() => {
        return () => {
            dispatch(setToolsInitialState())
        }
    }, [])

    return (
        <div className={"px-10 space-y-5"}>
            <TotalDataComponent subject={"wishlist"}/>
            <Wishlist dataSource={response?.data?.result ?? []} isLoading={isLoading}/>
        </div>
    )
}

export default TabWishlist
